import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-tryout-total-custom-questions',
  templateUrl: './tryout-total-custom-questions.component.html',
  styleUrls: ['./tryout-total-custom-questions.component.css']
})
export class TryoutTotalCustomQuestionsComponent implements OnInit {
  @Input() NoOfTotalQuestions: string;
  @Output() filterQuestionEvent = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  filterQuestionListing(value) {
    this.filterQuestionEvent.emit(value);
  }

}



// WEBPACK FOOTER //
// ./src/app/tryout/components/tryout-total-custom-questions/tryout-total-custom-questions.component.ts